import {Injectable} from '@angular/core';
import {AuthProvider} from '../../../domain/auth/auth-provider';
import {AppConfigService} from '../../../../service/config/app-config.service';
import {CachedWsResourceClient} from '../../../private_util/client/cached-http-ws-Resource-client';
import {RequestService} from '../../../service/request.service';
import {WsDaoEventEntityType, WsRef, WsTicketContact} from '@lifeislife/lifeislife-ws-api';
import {ResourceCacheService} from '../../../../util/cache/resource-cache.service';

@Injectable({
  providedIn: 'root',
})
export class TicketContactWsClient extends CachedWsResourceClient<WsTicketContact, WsRef<WsTicketContact>> {

  constructor(private injectedRequestService: RequestService,
              private injectectedCacheService: ResourceCacheService,
              private injectedAuthService: AuthProvider,
              private injectedAppConfigService: AppConfigService) {
    super('/front/ticketContact', injectedAppConfigService, injectedRequestService, injectedAuthService,
      WsDaoEventEntityType.TICKET_CONTACT, injectectedCacheService);
  }

}
